import { immerable } from 'immer'
import { useState, useRef } from 'react'
import useComputed from '@/hooks/use-computed'
import isObject from '@/utils/is-object.js'
import api from '@/services/api/filter.js'
import KeyHelper from '@/utils/key-helper'

const useFilter = () => {
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	const [filter, setFilter] = useComputed()

	const lastRequestPayloadKeyRef = useRef(null)

	async function fetch(parameter) {
		const currentPayloadKey = KeyHelper.createKeyOfObject({ parameter })

		if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

		lastRequestPayloadKeyRef.current = currentPayloadKey

		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!isObject(data)) {
			return setError('Filter is not an object')
		}

		return setFilter(data)
	}

	async function find() {
		setLoading(true)

		const [error, data] = await api.index()

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!isObject(data)) {
			return setError('Filter is not an object')
		}

		return data
	}

	return {
		error,
		loading,
		filter,
		fetch,
		find,
	}
}

export default useFilter
